import type { RouteRecordRaw } from 'vue-router'

// Routes are defined separately so they can be imported by vite.config.ts
// for sitemap generation without triggering router creation
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/LandingView.vue'),
    meta: {
      sitemap: { priority: 1.0 },
    },
  },
  {
    path: '/registration-success',
    name: 'registration-success',
    component: () => import('@/views/RegistrationSuccessView.vue'),
    meta: {
      sitemap: { exclude: true },
    },
  },
  // Add more routes with lazy loading for code splitting:
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('@/views/AboutView.vue'),
  //   meta: {
  //     sitemap: { priority: 0.8, changefreq: 'monthly' },
  //   },
  // },
  // {
  //   path: '/admin',
  //   name: 'admin',
  //   component: () => import('@/views/AdminView.vue'),
  //   meta: {
  //     sitemap: { exclude: true }, // Exclude from sitemap
  //   },
  // },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: {
      sitemap: { exclude: true },
    },
  },
]
